<template>
    
   <div>
        <a href="https://www.facebook.com/profile.php?id=100091236781421" target="_blank"><img class="mb-2" src="@/assets/icons/facebook.svg"  ></a> 
        <a href="https://www.instagram.com/agence_pubag/" target="_blank"><img class="mb-2 pl-3" src="@/assets/icons/instagram.svg"  ></a>
        <a href="mailto:contact@pubag.tn"><img class="mb-2 pl-3" src="@/assets/icons/email.svg"></a>              
   </div>

</template>

<script>
export default ({
    name: "footer-Social"
})
</script>


